import { TuiSelectModule } from '@taiga-ui/kit';
import { TuiDataListModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { Maybe, Role } from '@iss/libs/graphql';
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  Inject,
  Input,
  Self,
  ViewEncapsulation,
} from '@angular/core';
import { NgForOf } from '@angular/common';

import { CapitalizePipe } from '@iss/wo-common/pipes';
import {
  Control,
  ControlStatusDirective,
  FormFieldComponent,
  LabelDirective,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-user-role-field',
  templateUrl: './user-role-field.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CapitalizePipe,
    ControlStatusDirective,
    FormFieldComponent,
    FormsModule,
    LabelDirective,
    NgForOf,
    ReactiveFormsModule,
    TuiDataListModule,
    TuiSelectModule,
    TuiTextfieldControllerModule,
  ],
})
export class UserRoleFieldComponent {
  @Input() public readonly: Maybe<boolean>;
  @Input() public roles: Maybe<readonly Role[]> = Object.values(Role);
  @Input() public showNecessity = true;
  @Input() public label: Maybe<string>;
  @Input() public clearable = false;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<Role | null>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
